import { RadioGroup } from "@radix-ui/react-dropdown-menu";
import React from "react";
import { breakpointClasses, cn, splitBreakpointProps } from "@/lib/utils";
import type { DropdownMenuRadioGroupProps } from "../types";

function DropdownMenuRadioGroup({
  className,
  ...props
}: DropdownMenuRadioGroupProps) {
  const { bp, native } = splitBreakpointProps(props);
  const classes = breakpointClasses(bp);

  return (
    <RadioGroup
      data-slot="dropdown-menu-radio-group"
      className={cn(className, classes)}
      {...native}
    />
  );
}

DropdownMenuRadioGroup.displayName = "DropdownMenu.RadioGroup";

export default DropdownMenuRadioGroup;
